/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Charactergreetingsola2Inputs */



/**
* | output |
* | --- |
* | "Buonasera! 😼" |
*
* @param {Charactergreetingsola2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const charactergreetingsola2 = /** @type {((inputs?: Charactergreetingsola2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Charactergreetingsola2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Buonasera! 😼")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Buonasera! 😼")
	return /** @type {LocalizedString} */ ("Буэносера! 😼")
});
export { charactergreetingsola2 as "characterGreetingSola" }